<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.85 18H8.15A1.16 1.16 0 017 16.85V3.15A1.16 1.16 0 018.15 2h10.7A1.16 1.16 0 0120 3.15v13.7A1.16 1.16 0 0118.85 18zM9 16h9V4H9z"/><path d="M15 22H4.15A1.16 1.16 0 013 20.85V7a1 1 0 012 0v13h10a1 1 0 010 2z"/></svg>